import React from 'react'
import { assetUrl } from '../helpers/urlBuilder'
import { withTranslation } from '../i18n'
import { isMobile } from './utils'

declare const initMap
declare const smartech

const GTM_ID = process.env.GOOGLE_TAG_MANAGER_ID

declare global {
	interface Window {
		render: () => void
	}
}
class FooterScripts extends React.PureComponent<any, any> {
	constructor(props) {
		super(props)
	}
	private _addScript(content: string, id?: string, toHead?: boolean) {
		const script = document.createElement('script')
		if (id) script.id = id
		script.innerHTML = content
		if (toHead) {
			document.head.append(script)
		} else {
			if (document.body !== undefined) {
				document.body.append(script)
			}
		}
	}

	private _addScriptWithSource(source: string, id?: string) {
		const script = document.createElement('script')
		script.src = source
		script.defer = true
		if (id) script.id = id
		document.body.append(script)
	}

	private _addGoogleTagManager() {
		const content = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`
		this._addScript(content, 'googleTagManager', true)
	}

	private _addGoogleAnalytics() {
		const CURRENT_LANGUAGE = this.props.i18n.language

		const content = `
            window.___gcfg = {lang: '${CURRENT_LANGUAGE}'};
            var _gaq = _gaq || [];
            window._gaq = _gaq;
            var pluginUrl =
                '//www.google-analytics.com/plugins/ga/inpage_linkid.js';
            _gaq.push(['_require', 'inpage_linkid', pluginUrl]);
            _gaq.push(['_setAccount', '${process.env.GA_ACCOUNT}']);
            _gaq.push(['_setDomainName', '${process.env.GA_DOMAIN}']);
            _gaq.push(['_trackPageview']);

            (function() {
                var ga = document.createElement('script');
                ga.type = 'text/javascript';
                ga.rel = 'preconnect';
                ga.async = true;
                ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'stats.g.doubleclick.net/dc.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ga, s);
            })();
            /* <![CDATA[ */
            var google_conversion_id = 1072665538;
            var google_conversion_label = "BRESCMD5mAMQwqe-_wM";
            var google_custom_params = window.google_tag_params;
            var google_remarketing_only = true;
            /* ]]> */
            function customEvent(uniqueName, action, label, value) {
                if (_gaq) {
                    // 'Videos', 'Play', 'First Birthday'
                    _gaq.push(['_trackEvent', uniqueName, action, label], value || 1); 
                }
            }`

		this._addScript(content, 'googleAnalytics')
	}

	private _addNetcoreApiScript() {
		const source = `https://cdnt.netcoresmartech.com/smartechclient.js`
		this._addScriptWithSource(source, 'netcoreApi')
	}

	private _addNetcore() {
		const content = `
        smartech('create', '${process.env.NETCORE_CREATE_KEY}' );
        smartech('register', '${process.env.NETCORE_REGISTER_KEY}');
        smartech('identify', '');

        var AppGA = (function () {
          function _send(hitType, category, action, label, value, properties) {
            var eventName = _getEventName(category, action, label);
            var mergedProperties = {};
            //get the hansel experience's data
            var hanselData = Hansel.logEvent(eventName, "ga", properties);
            if(!properties) {properties = {};}
            mergedProperties = Object.assign(properties, hanselData);
        
            ga('send', {
              hitType: hitType,
              eventCategory: category,
              eventAction: action,
              eventLabel: label,
              eventValue: value,
              properties: mergedProperties
            });
          }
        
          function _getEventName(category, action, label) {
            //You can change this logic to create a unique event name from category, action and label
            var eventName = (category || "Hansel") + (action || "click") + (label || "nudge");
            return eventName;
          }
        
          return {
            send : _send
          }
        })();`

		this._addScript(content, 'netcore')
	}

	private _addHotJarScript() {
		const content = `(function(h,o,t,j,a,r){
                        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                        h._hjSettings={hjid:1632895,hjsv:6};
                        a=o.getElementsByTagName('head')[0];
                        r=o.createElement('script');r.defer=1;
                        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                        a.appendChild(r);
                    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
		this._addScript(content, 'hotJar')
	}

	private _addIpToLocationScript() {
		const content = `
                        var jsMetaCities = ${
							this.props.metaCities
								? JSON.stringify(this.props.metaCities)
								: null
						};
                        var ipToLocationApi = "${
							process.env.IP_TO_LOCATION_API_URL
						}";`

		this._addScript(content)
	}

	private _addGeoCoderScript() {
		const source = assetUrl(
			`/static/js/geocoder.js?${process.env.VNW_BUILD_ID}`
		)
		this._addScriptWithSource(source, 'geoCoder')
	}

	private _addGoogleMapApiScript() {
		const source = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_API_KEY}&callback=initMap`
		this._addScriptWithSource(source, 'googleMapApi')
	}

	render() {
		// Note: we're not rendering anything, mostly add custom scripts to the document body
		// when this component is mounted
		return null
	}

	addFooterScripts() {
		if (typeof document !== 'undefined') {
			// Add Google Analytics right away
			this._addGoogleAnalytics()

			const addScriptEventListener = () => {
				// Add this right away
				this._addGoogleTagManager()

				// Add some secondary scripts
				setTimeout(() => {
					this._addIpToLocationScript()

					// This add GeoCoder which would make the method `initMap` available
					// for Google Map API
					this._addGeoCoderScript()

					// Since GoogleMapAPI depends on the `initMap` function,
					// we need to wait until it is defined
					const waitForInitMapToAddGoogleMapAPIScript = () => {
						if (typeof initMap !== 'undefined') {
							this._addGoogleMapApiScript()
						} else {
							setTimeout(
								waitForInitMapToAddGoogleMapAPIScript,
								200
							)
						}
					}
					waitForInitMapToAddGoogleMapAPIScript()
				}, 1000)

				// Add some other scripts
				setTimeout(() => {
					this._addHotJarScript()

					this._addNetcoreApiScript()

					const waitForSmartechConnect = () => {
						if (typeof smartech !== 'undefined') {
							this._addNetcore()
						} else {
							setTimeout(waitForSmartechConnect, 500)
						}
					}
					waitForSmartechConnect()
				}, 2000)
			}
			addScriptEventListener()
		}
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
			this.addFooterScripts()
		}
	}
}

// @ts-ignore
export default withTranslation('home')(FooterScripts)
